// Keep these in line with AuditLogEntity.cs
export const AuditLogEntity = {
  Unknown: 0,
  Sheet: 1,
};
